var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgConnect = function SvgConnect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#connect_svg__a)",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.209 7.528A28.564 28.564 0 0 0 26.345.1M.113 25.28s13.16-2.106 20.95-12.302m5.283-2.812H32m-31.887 0h19.155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.927 13.368c1.746 0 3.162-1.433 3.162-3.201s-1.416-3.202-3.162-3.202-3.161 1.434-3.161 3.202 1.415 3.201 3.161 3.201Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "connect_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h32v26H0z"
  })))));
};
export default SvgConnect;